// APP
export const APP_INIT_START = 'APP_INIT_START';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';
export const APP_INIT_FAILED = 'APP_INIT_FAILED';

// PSAP

export const GET_PSAP_INFO_START = 'GET_PSAP_INFO_START';
export const GET_PSAP_INFO_SUCCESS = 'GET_PSAP_INFO_SUCCESS';
export const GET_PSAP_INFO_FAILED = 'GET_PSAP_INFO_FAILED';

export const UPDATE_PSAP_INFO_START = 'UPDATE_PSAP_INFO_START';
export const UPDATE_PSAP_INFO_SUCCESS = 'UPDATE_PSAP_INFO_SUCCESS';
export const UPDATE_PSAP_INFO_FAILED = 'UPDATE_PSAP_INFO_FAILED';

// INTEGRATION TESTS

export const FETCH_OAUTH_START = 'FETCH_OAUTH_START';
export const FETCH_OAUTH_SUCCESS = 'FETCH_OAUTH_SUCCESS';
export const FETCH_OAUTH_ERROR = 'FETCH_OAUTH_ERROR';

export const USER_CREDS = 'USER_CREDS';
export const RESET = 'RESET';

export const FETCH_INTEGRATIONS_START = 'FETCH_INTEGRATIONS_START';
export const FETCH_INTEGRATIONS_SUCCESS = 'FETCH_INTEGRATIONS_SUCCESS';
export const FETCH_INTEGRATIONS_ERROR = 'FETCH_INTEGRATIONS_ERROR';

export const FETCH_AUTHORITY_ERROR = 'FETCH_AUTHORITY_ERROR';
export const FETCH_AUTHORITY_SUCCESS = 'FETCH_AUTHORITY_SUCCESS';
export const FETCH_AUTHORITY_START = 'FETCH_AUTHORITY_START';

export const UPDATE_TEST_RESULTS = 'UPDATE_TEST_RESULTS';

export const CREATE_ADELE_TEST_START = 'CREATE_ADELE_TEST_START';
export const CREATE_ADELE_TEST_SUCCESS = 'CREATE_ADELE_TEST_SUCCESS';
export const CREATE_ADELE_TEST_ERROR = 'CREATE_ADELE_TEST_ERROR';

export const START_ADELE_TEST_START = 'START_ADELE_TEST_START';
export const START_ADELE_TEST_SUCCESS = 'START_ADELE_TEST_SUCCESS';
export const START_ADELE_TEST_ERROR = 'START_ADELE_TEST_ERROR';

export const LEI_TEST_START = 'LEI_TEST_START';
export const LEI_TEST_SUCCESS = 'LEI_TEST_SUCCESS';
export const LEI_TEST_ERROR = 'LEI_TEST_ERROR';

export const LIS_TEST_START = 'LIS_TEST_START';
export const LIS_TEST_SUCCESS = 'LIS_TEST_SUCCESS';
export const LIS_TEST_ERROR = 'LIS_TEST_ERROR';

export const RAD_TEST_START = 'RAD_TEST_START';
export const RAD_TEST_SUCCESS = 'RAD_TEST_SUCCESS';
export const RAD_TEST_ERROR = 'RAD_TEST_ERROR';

export const HERMES_TEST_START = 'HERMES_TEST_START';
export const HERMES_TEST_SUCCESS = 'HERMES_TEST_SUCCESS';
export const HERMES_TEST_ERROR = 'HERMES_TEST_ERROR';

export const PSAP_DASHBOARD_TEST_START = 'PSAP_DASHBOARD_TEST_START';
export const PSAP_DASHBOARD_SUCCESS = 'PSAP_DASHBOARD_SUCCESS';
export const PSAP_DASHBOARD_ERROR = 'PSAP_DASHBOARD_ERROR';

export const ADELE_LOGGER_START = 'ADELE_LOGGER_START';
export const ADELE_LOGGER_ERROR = 'ADELE_LOGGER_ERROR';
export const ADELE_LOGGER_SUCCESS = 'ADELE_LOGGER_SUCCESS';

export const TEST_FINISHED = 'TEST_FINISHED';

export const RESET_RESULTS = 'RESET_RESULTS';
